import { LocalDate } from '@js-joda/core';

import { EntitlementStatementType, LegalBasis } from '@dreryk/egabinet-patient-frontend-api';

import { useFormController } from '@dreryk/react-common';
import { AutoLayout } from '@dreryk/react-components';
import { Range } from '@dreryk/watermelon';

import { DocumentTypeTextView } from '../../../common/EntitlementStatementForm/DocumentTypeTextView';
import { PrintWithExplanationsAndNoticeCheckbox } from '../../../common/EntitlementStatementForm/PrintWithExplanationsAndNoticeCheckbox';
import { StatementTypeField } from '../../../common/EntitlementStatementForm/StatementTypeField';
import { EntitlementStatementCreateModalProps } from '../modal/EntitlementStatementCreateModal';

import { EntitlementStatementCreateFormLoader } from './EntitlementStatementCreateFormLoader';
import { PatientEntitlementStatementCreateFormContent } from './PatientEntitlementStatementCreateForm';
import { RepresentativeEntitlementStatementCreateForm } from './RepresentativeEntitlementStatementCreateForm';

export type EntitlementStatementTypeBean = {
   entitlementStatementType: EntitlementStatementType;
   printWithExplanationsAndNotice: boolean;
};

export type EntitlementStatementCreateFormBean = {
   legalBasis: LegalBasis | null;
   submissionDate: LocalDate | null;
   effectiveDate: LocalDate | null;
   grantingDateFieldEnabled: boolean;
   grantingDate: Range<LocalDate>;
   printWithExplanationsAndNotice: boolean;
};

export type EntitlementStatementCreateFormProps = EntitlementStatementCreateModalProps;

export const EntitlementStatementCreateForm = (props: EntitlementStatementCreateFormProps): JSX.Element => {
   const { register, watch } = useFormController<EntitlementStatementTypeBean>({
      entitlementStatementType: 'FOR_BENEFICIARY',
   });

   const entitlementStatementType = watch('entitlementStatementType');

   return (
      <AutoLayout as={'form'} noValidate $direction={'vertical'} $horizontalResizing={750} $spacing={24}>
         <AutoLayout as={DocumentTypeTextView} $horizontalResizing={'fill'} />
         <AutoLayout $horizontalResizing={'fill'} as={'span'}>
            <PrintWithExplanationsAndNoticeCheckbox
               {...props}
               register={register}
               name={'printWithExplanationsAndNotice'}
            />
         </AutoLayout>
         <AutoLayout
            as={StatementTypeField}
            name={'entitlementStatementType'}
            register={register}
            required
            $horizontalResizing={'fill'}
         />
         <EntitlementStatementCreateFormLoader patientId={props.patientId}>
            {(responseProps) => (
               <>
                  {entitlementStatementType === 'FOR_BENEFICIARY' ? (
                     <PatientEntitlementStatementCreateFormContent {...props} {...responseProps} />
                  ) : (
                     <RepresentativeEntitlementStatementCreateForm {...props} {...responseProps} />
                  )}
               </>
            )}
         </EntitlementStatementCreateFormLoader>
      </AutoLayout>
   );
};
